<div @slideInStagger>
  <div class="row mt-4 slide-in-animation">
    <div class="col-md-12">
      <table class="table table-material box-shadow-hover table-responsive-sm">
        <thead class="thead-normal">
        <tr>
          <th class="text-center">{{"to_generate.column.project"|translate}}</th>
          <th class="text-center">{{"to_generate.column.purchase_order"|translate}}</th>
          <th class="text-center">{{"to_generate.column.period"|translate}}</th>
          <th>{{"to_generate.column.client"|translate}}</th>
          <th class="text-center">{{"to_generate.column.provider"|translate}}</th>
          <th class="text-center">{{"to_generate.column.quantity"|translate}}</th>
          <th class="text-center">{{"to_generate.column.action"|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let activitySheet of listContent">
          <td class="text-center">
            {{ activitySheet.projectName }}
          </td>
          <td class="text-center">
            {{ activitySheet.purchaseOrderNumber }}
          </td>
          <td class="text-center">
            {{ activitySheet.accountingMonth | date: "MMM yyyy" }}
          </td>
          <td>
            {{ activitySheet.buyerCompanyName }}
          </td>
          <td class="text-center">
            {{ activitySheet.employeeName }}
          </td>
          <td class="text-center">
            {{ activitySheet.sum }} {{ ("global.common." + (activitySheet.type | lowercase)) | translate }}
          </td>
          <td class="text-center">
            <isp-button
              class="px-1"
              [type]="ButtonTypeEnum.ICON"
              [icon]="faPenToSquare"
              [colour]="IspColoursEnum.primary"
              [tooltip]="(!requestBlocked.includes(activitySheet.requestId) ? 'to_generate.button_generate':'to_generate.waiting_amendment')|translate"
              [disabled]="requestBlocked.includes(activitySheet.requestId)"
              (trigger)="!requestBlocked.includes(activitySheet.requestId) ? generateInvoice(activitySheet) : null"
              [size]="SizeEnum.xs"
            ></isp-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>
